import React, { useRef, useEffect, useState, useCallback } from 'react';

export default function SectionTitle({ text, direction = 'left' }) {
  const ref = useRef(null);
  const [range, setRange] = useState(direction === 'right' ? -25 : 5);

  const update = useCallback(() => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const viewH = window.innerHeight;
    const progress = 1 - (rect.bottom / (viewH + rect.height));
    const val = direction === 'right'
      ? -25 + progress * 30
      : 5 - progress * 30;
    setRange(val);
  }, [direction]);

  useEffect(() => {
    const lenis = window.__lenis;
    if (lenis) {
      const handler = () => update();
      lenis.on('scroll', handler);
      update();
      return () => lenis.off('scroll', handler);
    }
    // Fallback: native scroll
    const handler = () => requestAnimationFrame(update);
    window.addEventListener('scroll', handler, { passive: true });
    update();
    return () => window.removeEventListener('scroll', handler);
  }, [update]);

  const repeated = Array(8).fill(text).join(' \u00B7 ') + ' \u00B7 ';

  return (
    <div
      ref={ref}
      className="relative my-4 md:my-6 overflow-hidden"
      style={{ width: '100vw', marginLeft: 'calc(-50vw + 50%)' }}
    >
      <div
        className="whitespace-nowrap select-none"
        style={{ transform: `translate3d(${range}%, 0, 0)` }}
      >
        <h2
          className="text-white italic m-0 p-0 font-normal"
          style={{
            fontFamily: "'Instrument Serif', serif",
            fontSize: 'clamp(6rem, 18vw, 22rem)',
            lineHeight: 0.95,
          }}
          data-testid={`section-title-${text.toLowerCase().replace(/\s+/g, '-')}`}
        >
          {repeated}
        </h2>
      </div>
    </div>
  );
}
